import React, { useEffect, useContext } from 'react'

import { SOCIAL_LOGIN_API } from '../../utils/apiUrls'
import { useNavigate } from 'react-router'
import { AppContext } from '../../context/app'
import useAxios from 'axios-hooks'
import Logo from '../../assets/socialLogin/google-social-login.png'
import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth' // Add this line

const firebaseConfig = {
  apiKey: 'AIzaSyC_w0Wlv1wlmae98zDZhwJaD4TtqfHrU_M',
  authDomain: 'auth.ikimhub.my',
  projectId: 'ikim-298ed',
  storageBucket: 'ikim-298ed.firebasestorage.app',
  messagingSenderId: '27757845560',
  appId: '1:27757845560:web:ddb72e6c93f92bbc93dacd',
}

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp()

const GoogleAuth = ({ textColor = '#dcdcdc', borderColor = '#dddddd', isModal = false }) => {
  const navigate = useNavigate()
  const { setLoader, setUser, setOpenLoginModal } = useContext(AppContext)

  const [{ data: loginRes, loading: loginResLoading }, loginCall] = useAxios(
    {
      url: SOCIAL_LOGIN_API,
      method: 'post',
    },
    { manual: true },
  )
  useEffect(() => {
    if (loginRes && loginRes.success) {
      setUser(loginRes?.data)
      if (isModal) {
        setOpenLoginModal(false)
      } else {
        navigate(`/`)
      }
    }
  }, [loginRes])

  useEffect(() => {
    setLoader(loginResLoading)
  }, [loginResLoading])

  // Initialize Auth and Provider
  const auth = getAuth(app)
  const googleProvider = new GoogleAuthProvider()

  const signInWithGoogle = () => {
    signInWithPopup(auth, googleProvider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result)
        const token = credential.idToken || credential.accessToken

        loginCall({
          data: {
            provider: 'google',
            token: token,
          },
        })
      })
      .catch((error) => {
        console.error('Login Failed', error)
      })
  }

  return isModal ? (
    <div
      style={{ width: '105px', height: '30px', background: '#dddddd' }}
      className="rounded text-sm flex items-center justify-center cursor-pointer"
      onClick={signInWithGoogle}
    >
      <img src={Logo} alt="Google Logo" style={{ width: '18px', height: '18px' }} />
      <p style={{ color: '#393939', marginLeft: '8px' }} className="">
        Google
      </p>
    </div>
  ) : (
    <div
      style={{ border: `0.5px solid ${borderColor}`, height: '30px', color: textColor }}
      className="w-full rounded flex items-center justify-center overflow-hidden relative cursor-pointer"
      onClick={signInWithGoogle}
    >
      <div
        style={{ width: '38px' }}
        className="absolute left-0 h-full flex items-center justify-center bg-white"
      >
        <img src={Logo} alt="Google Logo" style={{ width: '18px', height: '18px' }} />
      </div>
      <p className="text-sm">Continue with Google</p>
    </div>
  )
}

export default GoogleAuth
